/**
 * Created by dimah on 18/06/17.
 */
import { ILanguage } from "@signature-it/ngx-generic/interfaces";
import { AbstractDTO } from "./abstract";

export class LanguageDTO extends AbstractDTO implements ILanguage {

    id: number;
    name: string;
    origin: string;
    code: string;
    flag: string;
    order: number;
	domain: string;
    ga_account: Array<string>;
    facebook_id: string;
    is_current: boolean;
    is_default: boolean;
    og_locale: string;
    og_site_name: string;
    landing_page: string;

    constructor(attributes: object) {
        super(attributes);
        attributes = attributes || {};

        this.id = Number(attributes["id"]) || 0;
        this.name = attributes["name"] || "";
        this.origin = attributes["origin"] || "";
        this.code = attributes["code"] || "";
        this.flag = attributes["flag"] || "";
        this.order = Number(attributes["order"]) | 0;
        this.domain = attributes["domain"] || "";
        this.ga_account = attributes["ga_account"] && typeof attributes["ga_account"] === 'string' ? attributes["ga_account"].split("|") : attributes["ga_account"] || [];
        this.facebook_id = attributes["facebook_id"] || "";
        this.is_current = attributes["is_current"] == true;
        this.is_default = attributes["is_default"] == true;
        this.og_locale = attributes["og_locale"] || "";
        this.og_site_name = attributes["og_site_name"] || "";
        this.landing_page = attributes["landing_page"] || "";
    }

}
